/**
 * Gets the current percentage based on the min, max, and current value.
 *
 * @param min - the min value
 * @param max - the max value
 * @param value - the current value to compare against
 * @returns the percentage that the `value` is between the `min` and `max`
 * values.
 */
export function getPercentage(min, max, value) {
    if (min >= max) {
        throw new RangeError("A range must have the min value less than the max value");
    }
    if (value > max || value < min) {
        throw new RangeError("A value must be between the min and max values");
    }
    var range = max - min;
    var start = value - min;
    var percentage = start / range;
    return Math.max(0, Math.min(Math.abs(percentage), 1));
}
//# sourceMappingURL=getPercentage.js.map